import { Injectable } from '@angular/core';

import { GridDataService } from '../../base-data-services/grid-data.service';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL, ASSIGNMENT_GRID_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams, GridPostParams } from 'common/models/utility-models/list-utility.model';
import { AssignmentModel } from 'common/models/page-models/Assignments Model/assignment-data.model';
import { AssignmentListingModel, AssignmnetGridParams } from 'common/models/page-models/Assignments Model/assignment-params.model';


@Injectable({
    providedIn: 'root'
})
export class AssignmentGridDataService extends GridDataService<AssignmentListingModel, AssignmentModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.getAssignements, http, ss);
    }

    createInstance(): AssignmentListingModel {
        return new AssignmentListingModel();
    }

    override getGridParams(param): GridPostParams {
        return {};
    }

    getDeleteUrl() {
        return '';
    }
    // override getDataParam() {
    //     return 'assignment_detail';
    // }

    override modifyResponse(response: any) {
        // Check if response contains the details array
        if (response.details && response.details.length > 0) {
          response.details.forEach((detail) => {
            // Check if timeslot_info exists in the current detail object
            if (detail.timeslot_info && detail.timeslot_info.length > 0) {
              detail.timeslot_info.forEach((timeslot) => {
                // Concatenate start_date and end_date with a hyphen
                timeslot.date_range = `${timeslot.start_date} - ${timeslot.end_date}`;
                // console.log(timeslot.date_range,"date_range");
                detail.date_range = timeslot.date_range;
              });
            }
          });
        }
        
        return response;
      }
      

    override transformDataModel(data: any, param) {
        super.transformDataModel(data, 'details');
        // console.log(data,param,'transformDataModel')
        // this.setSystemServiceData('name', API_URL.emailList, ' ', 'detail');
        // this.setSystemServiceData('batch_number', API_URL.batchList, ' ', 'detail');
        // this.setSystemServiceData('branchCategory', API_URL.getDepartmentTypeList, ' ', 'detail');
        // this.setSystemServiceData('zone_name', API_URL.zoneList, ' ', 'detail');
        // this.setSystemServiceData('category_name', ASSIGNMENT_GRID_URL.getCatList, ' ', 'detail');
        // this.setSystemServiceData('cityName', API_URL.getCityList, ' ', 'detail');
        // this.setSystemServiceData('type_name', API_URL.newTypeList, ' ', 'detail');
        // this.setSystemServiceData('trainer', API_URL.trainersGrid, {user_id:this.ss.getUserRole()}, 'detail');
        // this.setSystemServiceData('students', API_URL.studentsGrid, ' ', 'detail');
        // this.setSystemServiceData('group_name', API_URL.getGroupList, ' ', 'detail');
        // console.log(data[param])
        data[param].forEach((data) => {
            data['travel'] = data['travelReimbursementFlag'] === 1 ? 'Travel Reimbursement' : '';
            data['trainerView'] = 'Trainer';
        });

        



        // data[param].forEach((data) => {
        //     data['travel'] = data['travelReimbursementFlag'] === '1' ? 'Travel Reimbursement' : '';
        //     data['isTravelReimbursement'] = data.travelReimbursementFlag === '0' ? false: true;
        //     if (data.slot_info.length === 1) {
        //         if (data.slot_info[0].start_date.split(' ')[0] === data.slot_info[0].end_date.split(' ')[0]) {
        //             // Single slot, single date - Use full start date
        //             data.dueDateTransformed = `${data.slot_info[0].start_date.split(' ')[0]}\n` + `${this.ss.formatTime(data.slot_info[0].start_date.split(' ')[1], 'hh:mm')} -
        //           ${this.ss.formatTime(data.slot_info[0].end_date.split(' ')[1], 'hh:mm')}`
        //         } else {
        //             // Single slot, multiple dates
        //             data.dueDateTransformed = `${data.slot_info[0].start_date.split(' ')[0]}
        //           ${this.ss.formatTime(data.slot_info[0].start_date.split(' ')[1], 'hh:mm')} -
        //           ${data.slot_info[0].end_date.split(' ')[0]}
        //           ${this.ss.formatTime(data.slot_info[0].end_date.split(' ')[1], 'hh:mm')}`
        //         }
        //     } else {
        //         // Multiple slots - Use starting date's year-month-day part
        //         const startDate = data.slot_info[0].start_date;
        //         const startTime = this.ss.formatTime(startDate.split(' ')[1], 'hh:mm');
        //         const endDate = data.slot_info[data.slot_info.length - 1].end_date;
        //         const endTime = this.ss.formatTime(endDate.split(' ')[1], 'hh:mm');

        //         // Combine formatted date and time information
        //         let dueDateTransformed = `${startDate.split(' ')[0]} ${startTime}`;

        //         // Add time ranges for each slot within the loop
        //         for (let i = 1; i < data.slot_info.length; i++) {
        //             const slot = data.slot_info[i];
        //             const slotStartTime = this.ss.formatTime(slot.start_date.split(' ')[1], 'hh:mm');
        //             const slotEndTime = this.ss.formatTime(slot.end_date.split(' ')[1], 'hh:mm');
        //             dueDateTransformed += `, ${slotStartTime} - ${slotEndTime}`;
        //         }

        //         data.dueDateTransformed = dueDateTransformed;
        //     }



        //     let assignments = '';
        //     for (let i = 0; i < data.slot_info.length; i++) {
        //         const item = data.slot_info[i];
        //         let val = item.accepted_student > 0 ? item.accepted_student : 'N/A';
        //         assignments += `${val}\n`;
        //     }
        //     data.acceptedAssignments = assignments;
        //     let trainerView = '';
        //     for (let i = 0; i < data.slot_info.length; i++) {
        //         const item = data.slot_info[i];
        //         if (item.is_superadmin !== 1) {
        //             let val = 'Trainer'+''
        //             trainerView += `${val}\n`;
        //         }


        //     }
        //     data.trainerView = trainerView;


        // });
        return data;
    }

}
